import { CheckBox } from "../../components/choices/CheckBox";
import { Radio } from "../../components/choices/Radio";
import { ImageSelect } from "../../components/choices/ImageSelect";
import { TextBoxControl } from "../../components/controls/TextBoxControl";
import { DropDownControl } from "../../components/controls/DropDownControl";
import { SliderControl } from "../../components/controls/SliderControl";
import { StarRatingControl } from "../../components/controls/StarRatingControl";
import { AxisModel } from "../AxisModel";
import { ColumnType } from "../enums/ColumnType";

export function controlTypeForColumn(column: AxisModel) {
    switch (column.type) {
        case ColumnType.CheckBox:
            return CheckBox;
        case ColumnType.RadioButton:
            return Radio;
        case ColumnType.ImageSelector:
            return ImageSelect;
        case ColumnType.DropDownList:
            return DropDownControl;
        case ColumnType.Slider:
            return SliderControl;
        case ColumnType.StarRating:
            return StarRatingControl;
        default:
            return TextBoxControl;
    }
}
